import { Integration } from '../integration';
import { ISemanticEvent, SemanticContext } from '../semanticEvents';

const trim = (arr: unknown[]) => {
  let i = arr.length - 1;
  while (i > 0 && !arr[i]) i--;
  return arr.slice(0, ++i);
};
const nameToBeacon = (e: ISemanticEvent) => trim([e.subject, e.action, e.object || null, e.result || null]);

export const semanticEventToBeacon = (event: ISemanticEvent, ctx?: SemanticContext) => {
  return trim([
    Math.ceil(event.timestamp / 1000),
    nameToBeacon(event),
    event.payload || null,
    ctx?.session_id || null,
    ctx?.client?.client_id || null,
    ctx?.device_id,
    ctx?.mobile,
    ctx?.ua,
  ]);
};

export type DWHOptions = {
  url: string | URL;
};

export class DWH implements Integration {
  readonly #url: URL | string;
  readonly displayName = 'DWH';
  constructor(options: DWHOptions) {
    this.#url = options.url;
  }

  trackEvent(event: ISemanticEvent, ctx: SemanticContext) {
    navigator.sendBeacon(this.#url, JSON.stringify(semanticEventToBeacon(event, ctx)));
  }
}
